import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiCallAdmin } from "../../services/api-service.js";

import { Container } from "react-bootstrap";
import gate_icon from "../../Assets/svg/tickgo-logo.svg";
import { useGlobal } from "../../GlobalContext.js";

function PreLanding() {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();
  const { setRolePermissionList, setUserType } = useGlobal();

  function deleteCookie(name) {
    document.cookie =
      name +
      "=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }

  function redirectToLogin() {
    deleteCookie("redirectPath");
    document.cookie =
      "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
    document.cookie = "mawalog=; path=/; domain=.mawalog.com";
    window.location.href = accountsUrl;
  }


  useEffect(() => {
    const fetchData = async () => {
      const response = await apiCallAdmin("get", "get_role_permission/28");

      if (response?.status === 401) {
        redirectToLogin();
        return;
      }

      if (response?.status === 200) {
        if (response.data.success === true) {
          setUserType(response.data.user_type);
          setRolePermissionList(response.data.role_permission ?? []);
          localStorage.setItem(
            "rolePermissionList",
            JSON.stringify(response.data.role_permission ?? [])
          );
          localStorage.setItem("userType", response.data.user_type ?? "");
        } else {
          setRolePermissionList([]);
        }

        navigate("/dashboard");
        return;
      }

      redirectToLogin();
    };

    fetchData();
  }, [accountsUrl, navigate, setRolePermissionList, setUserType]);


  return (
    <Container
      fluid
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      <img src={gate_icon} alt="TickGo Icon" width={"500px"} />
    </Container>
  );
}

export default PreLanding;
